import { Grid2 as Grid } from "@mui/material";
import { HeaderData } from "./components/HeaderData";
import { EAFChart } from "./components/charts/eaf-chart/EAFChart";
import { AdditionsTable } from "./components/tables/additions-table/AdditionsTable";
import { ChargesTable } from "./components/tables/charges-table/ChargesTable";
import { DelaysTable } from "./components/tables/delays-table/DelaysTable";
import { HeatingsTable } from "./components/tables/heatings-table/HeatingsTable";
import { PhasesTable } from "./components/tables/phases-table/PhasesTable";
import { ProbesTable } from "./components/tables/probes-table/ProbesTable";

export const EAFProcessData = () => {
	return (
		<Grid container spacing={1}>
			<Grid size={{ xs: 12 }}>
				<HeaderData />
			</Grid>

			<Grid size={{ xs: 2 }}>
				<AdditionsTable />
			</Grid>
			<Grid size={{ xs: 2 }}>
				<ProbesTable />
			</Grid>
			<Grid size={{ xs: 2 }}>
				<ChargesTable />
			</Grid>
			<Grid size={{ xs: 3 }}>
				<PhasesTable />
			</Grid>
			<Grid size={{ xs: 3 }}>
				<HeatingsTable />
			</Grid>

			<Grid size={{ xs: 12 }}>
				<EAFChart />
			</Grid>

			<Grid size={{ xs: 12 }}>
				<DelaysTable />
			</Grid>
		</Grid>
	);
};
